<template>
  <div id="dictionaries">
    <template v-if="$route.name == 'dictionariesList'">
      <div class="content-top row">
        <div class="col-24 d-flex justify-content-between align-items-center">
          <div class="content-top__title-box">
            <h1 class="content-top__heading">Słowniki</h1>
          </div>
        </div>
      </div>
      <div class="content">
        <p>Wybierz słownik z menu powyżej.</p>
        <DictionariesSync />
      </div>
    </template>

    <router-view :key="$route.path"></router-view>
  </div>
</template>
<script>
import DictionariesSync from "./DictionariesSync.vue";

export default {
  components: {
    DictionariesSync,
  },
};
</script>
